import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ProductlistService } from '../productlist/productlist.service';
import { InventoryService } from './inventory.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DatepickerServiceInputs } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { AddproductService } from '../addproduct/addproduct.service';
declare const $: any;

@Component({
  selector: 'app-lowinventory',
  templateUrl: './lowinventory.component.html',
  styleUrls: ['./lowinventory.component.css']
})
export class LowinventoryComponent implements OnInit, AfterViewInit {
  public LowinventoryProductList: any[] = [];
  public dataForSubmit: any[] = [];
  public changesInItemDetails: { [key: number]: { quantity: number, price: number } } = {};
  public searchText: string = '';
  public form: any;
  private loginUserId: number = 0;
  public readonly rootURL: string = environment.baseUrl.slice(0, -3);
  public paginationconfig = {
    itemsPerPage: 10,
    currentPage: 1,
    pageIndex: 0
  };
  constructor(private inventoryservice: InventoryService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private addproductservices: AddproductService) {
    this.form = fb.group({
      productDetailId: ['', [Validators.required]],
      productQuantity: [0, [Validators.required, Validators.min(1)]],
      productPrice: [0, [Validators.required, Validators.min(1)]],
    });

  }

  ngOnInit(): void {
    this.getLowInventoryProducts();
  }

  ngAfterViewInit(): void {
    $(`.date-input`).flatpickr({
      minDate: 'today',
      dateFormat: 'd/M/Y'
    });
  }

  get f() {
    return this.form.controls;
  }

  enableDisabledInventory(productItemId: number, IsActive: boolean) {
    Swal.fire({
      title: IsActive
        ? "Are you sure you want to disable the product inventory?"
        : "Are you sure you want to enable the product inventory?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#297084',
      cancelButtonColor: '#686767',
      confirmButtonText: "Confirm"
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.inventoryservice.enableDisabledInventory(productItemId).subscribe(response => {
          this.getLowInventoryProducts();
          this.toastr.success(response.activity);
        }, err => { this.spinner.hide(); this.toastr.error('Not Responding'); });
      }
      else {
        function check() {
          $('#enabled-disabled' + productItemId).prop("checked", true)
        };
        function uncheck() {
          $('#enabled-disabled' + productItemId).prop("checked", false)
        };

        IsActive ? check() : uncheck();
      }
    })

  }

  getLowInventoryProducts() {
    this.spinner.show();
    this.inventoryservice.GetLowInventroyProducts().subscribe({
      next: (response) => {
        if (response.message === 'Success') {
          this.LowinventoryProductList = response.result;
        };
        setTimeout(() => {
          this.spinner.hide();
        }, 300);
      },
      error: (err) => {
        this.toastr.error(err)
        this.spinner.hide();
      }
    });
  }

  OnTableDataChange(pageNumber: number) {
    this.paginationconfig.currentPage = pageNumber;
  }

  setDefaultImage(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/images/default-product.png';
  }

  appendQuantity() {
    debugger
    if (this.form.valid) {
      this.dataForSubmit = [...this.dataForSubmit.filter(x => x.productDetailId !== this.form.get('productDetailId').value), this.form.value];
      this.changesInItemDetails[this.form.get('productDetailId').value] = { quantity: this.form.get('productQuantity').value, price: this.form.get('productPrice').value };;
      this.formReset();
    } else {
      this.form.markAllAsTouched();
    }
  }

  addQuantity() {
    this.spinner.show();
    this.inventoryservice.AddProductStock(this.dataForSubmit).subscribe({
      next: (response) => {
        if (response.message === 'Success') {
          Swal.fire({
            title: 'Inventory Updated!',
            text: `New lot (${response.result}) has been successfully created for the selected products.`,
            icon: 'success'
          });
          this.dataForSubmit = [];
          this.changesInItemDetails = {};
          this.getLowInventoryProducts();
        } else { this.toastr.error(response.message) };
        this.spinner.hide();
      },
      error: (err) => {
        this.toastr.error(err)
        this.spinner.hide();
      }
    })
  }


  formReset() {
    $('#add-stock-modal').modal('hide');
    this.form.reset({ productPrice: 0, productQuantity: 0 });
  }

  openModal(item: { itemPrice: number, id: number }): void {
    this.form.patchValue({
      productDetailId: item.id,
      productPrice: this.changesInItemDetails[item.id] ? this.changesInItemDetails[item.id].price : item.itemPrice,
    });
    $('#add-stock-modal').modal('show');
  }
}
